import { RouteDetail } from '../types/sms';
import { mapPort } from './mapPort';
import { RouteInformation } from '../types/api';

export const mapRouteInformationToRouteDetails = (route: RouteInformation): RouteDetail => ({
  ports: route.ports.map(mapPort),
  textCode: route.textCode || '',
  routeId: route.id || '',
});
